import React from "react";
import Range from "./Range";

function ProgressBar(props) {

    return (
        <div className="progress-bar">
            {/*render available progress bar’s limit*/}
            <Range percentRange={props.percentRange}/>
        </div>
    );
}

export default ProgressBar;